import { useState } from "react"

export const useForm = (initialValues = {}) => {

    const [ form, setForm ] = useState(initialValues)
    const [ error, setError ] = useState(null);    

    const handleChange = ( { target } ) => {
        const { name, value } = target

        setForm({
            ...form,
            [ name ]: value,
        })
    }

    const validate = ( fieldValues = {} ) => {
        const errors = {};

        if('email' in fieldValues){
            errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldValues.email) ? "" : 'El correo electrónico no es valido'
        }

        if(!fieldValues.email){
            errors.email = 'El correo electrónico es obligatorio'
        }

        if('psw' in fieldValues){
            errors.psw = fieldValues.psw.length > 4 ? "" : 'La contraseña debe ser mayor a 10 caracteres'
        }

        if(!fieldValues.psw){
            errors.psw  = 'La contraseña es obligatorio'
        }

        if(fieldValues.psw && fieldValues.confirmPassword){
            if(fieldValues.psw !== fieldValues.confirmPassword){
                errors.confirmPassword = 'Las contraseñas no coinciden';
            } 
        }

        if(fieldValues.phone){
            const phoneParams = /^[+]?[0-9]{7,10}$/;
            errors.phone = phoneParams.test(fieldValues.phone) ? "" : "Número de telefono no válido"
        }

        setError(errors)

        return {
            isValid: Object.keys(errors).length === 0,
            errors: errors
        }
    }

    const handleSubmit = async (onSubmit, onError) => {
        
        try {
            if (!validate(form)) {
                onError(error);
                return;
            }
            
            await onSubmit(form);
        } catch (error) {
            console.error('Error al enviar el formulario:', error);
            onError(error);
        }
    }

    const resetForm = () => {
        setForm(initialValues);
        setError(null);
    };

    const getInputProps = (inputConfig) => {
        const { name, value, onChange, className } = inputConfig;
        
        return {
            id: inputConfig.id,
            name: name,
            type: inputConfig.type || "text",
            value: value ?? form[name],
            onChange: onChange || handleChange,
            required: inputConfig.required,
            className: `${className || ''}`,
        };
    };

    return{
        form,
        handleChange,
        validate,
        handleSubmit,
        resetForm,
        getInputProps,
        error,
        ...form
    }
}